import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  AppBar,
  Toolbar,
  Typography
} from '@mui/material';
import LandingPage from './components/LandingPage';
import Dashboard from './components/Dashboard';
import {handleRequestConsent, pollConsentStatus, requestFinancialInfo, pollFinancialStatus, fetchFinancialData} from './utils/api.js'

function App() {
  const [currentPage, setCurrentPage] = useState('landing');
  const [userDetails, setUserDetails] = useState(null);

  // ✅ GLOBAL FINANCIAL DATA STORE
  const [financialData, setFinancialData] = useState({});
  const [loadingType, setLoadingType] = useState(null);
  const [error, setError] = useState(null);

  const fetchFinancialDataForInstrument = async (type, templateId) => {
    if (!userDetails) return;

    try {
      setLoadingType(type);
      setError(null);

      const clientRequestId = await handleRequestConsent(
        templateId,
        userDetails
      );

      await pollConsentStatus(clientRequestId);

      const fiId = await requestFinancialInfo(clientRequestId);
      await pollFinancialStatus(fiId);

      const rawData = await fetchFinancialData(fiId);
      console.log("RAW DATA",rawData)
      // ✅ NORMALIZED DATA SHAPE

      setFinancialData(prev => ({
        ...prev,
        [type]: rawData
      }));

    } catch (err) {
      console.error(err);
      setError('Failed to fetch financial data. Please try again.');
    } finally {
      setLoadingType(null);
    }
  };

  useEffect(() => {
    const savedUser = localStorage.getItem('userDetails');
    if (savedUser) {
      setUserDetails(JSON.parse(savedUser));
      setCurrentPage('dashboard');
    }
  }, []);

  const handleLogin = (details) => {
    setUserDetails(details);
    localStorage.setItem('userDetails', JSON.stringify(details));
    setCurrentPage('dashboard');
  };

  const handleLogout = () => {
    setUserDetails(null);
    localStorage.removeItem('userDetails');
    setCurrentPage('landing');
  };

  return (
    <div>
      <AppBar position="static" sx={{ backgroundColor: '#000000' }}>
        <Toolbar>
          <a href="https://marcellus.in" target='_blank' rel="noopener noreferrer">
            <img 
              src="/assets/Marcellus-Logo.png" 
              alt="Company Logo" 
              style={{ height: 20, marginRight: 30 }} 
            />
          </a>
        </Toolbar>
      </AppBar>

      {currentPage === 'landing' && <LandingPage onLogin={handleLogin} />}
      {currentPage === 'dashboard' && (
        <Dashboard
          user={userDetails}
          onLogout={handleLogout}
          financialData={financialData}
          loadingType={loadingType}
          error={error}
          onFetch={fetchFinancialDataForInstrument}
        />
      )}

      <Box component="footer" sx={{ bgcolor: '#000', color: 'white', py: 3, textAlign: 'center' }}>
        <Typography variant="body2">
          © 2025 Marcellus Investment Managers. All rights reserved.
        </Typography>
        <Typography variant="caption" color="grey.500">
          Powered by Account Aggregator Framework
        </Typography>
      </Box>
    </div>
  );
}

export default App;